//#region Function Imports
import React, { useState, useEffect } from 'react'
import { FlatList, StyleSheet, SafeAreaView, View, Platform, useWindowDimensions } from 'react-native'
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton/CustomButton';
import { Card } from 'react-native-paper';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native-gesture-handler';
import { useSafeAreaInsets } from "react-native-safe-area-context";

//#endregion

const MySurveys = (props) => {

    //#region Function Consts
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions()
    const { colors } = useTheme()
    const styles = makeStyles(colors, height, width);
    const [loading, setLoading] = useState(false);
    const insets = useSafeAreaInsets();
    //#endregion

    //#region Useeffect
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    //#endregion

    //#region Render Functions
    const SurveyListView = (item) => {
        var date = new Date(Date.parse(item.completed_on));
        return (
            <View style={styles.showhide}>
                <SafeAreaView>
                    <SafeAreaView>
                        <SafeAreaView
                            style={Platform.OS === 'web' && width > 1300 ? styles.row : styles.column}>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={item.survey_name}
                                    type='AVAILABLEUSED' />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={item.instructions}
                                    type='AVAILABLEUSED_SECONDARY' />
                            </SafeAreaView>
                            {item?.completed_on !== undefined ?
                                <View
                                    style={styles.button}>
                                    <CustomLabel
                                        value={date.getUTCDate() + "/" + (date.getMonth() + 1) + "/" + (date.getFullYear())}
                                        type='AVAILABLEUSED' />
                                </View> :
                                <View
                                    style={styles.button}>
                                    <CustomButton
                                        type="COMPLETE"
                                        text={t('common:surveycomplete')}
                                        onPress={() => {
                                            props.setShowMySurveys(0)
                                            props.setShowResponseScreen(1)
                                            props.setResponseSurveyId(item.id)
                                        }}
                                        show="HIDE"
                                    />
                                </View>}
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </View >
        )
    }

    const renderSurveys = ({ item }) => {
        if (item.require_login === false)
            return (<></>)
        return (
            <Card
                style={styles.cardstyle} >
                <Card.Content>
                    <SurveyListView {...item} />
                </Card.Content>
            </Card >
        )
    };
    //#endregion

    return (
        <SafeAreaView style={[styles.mainView, {paddingBottom: Math.max(insets.bottom + 24, 40)}]}>
            <View style={styles.listWrapper}>
                <FlatList
                    data={props.data}
                    renderItem={renderSurveys}
                    onRefresh={() => props.loadEverySurvey()}
                    scrollEnabled={true}
                    refreshing={loading}
                    contentContainerStyle={{ flexGrow: 1 }}
                    keyExtractor={item => `${item.id}`}
                    initialNumToRender={4}
                    ListHeaderComponent={
                        <SafeAreaView>
                            {(Platform.OS === 'web' && width > 1300) &&
                                <View style={styles.row}>
                                    <CustomLabel
                                        value={t('common:surveyname')}
                                        type='SUBTITLE' />

                                    <CustomLabel
                                        value={t('common:surveyinstructions')}
                                        type='SUBTITLE' />
                                    <CustomLabel
                                        value={t('common:surveycompletedon')}
                                        type='SUBTITLE' />
                                </View>}
                        </SafeAreaView>
                    }
                />
            </View>
        </SafeAreaView>
    )
}

const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        height: (Platform.OS === 'web' ? height * 60 / 100 : '95%'),
        justifyContent: 'center',
    },
    listWrapper: {
        flex: 1,
        padding: Platform.OS === 'web' ? 10 : 1,
        marginBottom: 10
    },
    cardstyle: {
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
        overflow: 'hidden',
        marginVertical: 16,
    },
    row: {
        flex: 1,
        flexDirection: "row",
    },
    column: {
        flex: 1,
        justifyContent: 'space-evenly',
    },
    margin: {
        marginTop: Platform.OS === 'web' && width > 1300 ? '0%' : '3%',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    item: {
        flex: 1,
        margin: 10,
    },
    button: {
        flex: 1,
        justifyContent: 'center',
        alignSelf: Platform.OS === 'web' ? "center" : undefined,
        alignItems: "center",
    },
})

export default MySurveys
